var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TextContent',{class:{
    'article-text': !_vm.isObjectiveTrivia,
    'article-text--trivia--statement': _vm.isObjectiveTrivia && _vm.isStatement,
    'article-text--trivia': _vm.isObjectiveTrivia,
  },attrs:{"content":_vm.content,"trusted-content":_vm.trustedContent,"ignore-formulas":_vm.ignoreFormulas}})}
var staticRenderFns = []

export { render, staticRenderFns }